export const normalizePhoneDigits = (value) => String(value ?? "").replace(/\D/g, "");

export const normalizePhoneForStorage = (value) => {
  const source = String(value ?? "").trim();
  let digits = normalizePhoneDigits(source);
  if (!digits) return "";

  let isExplicitInternational = source.startsWith("+");
  if (digits.startsWith("00")) {
    digits = digits.slice(2);
    isExplicitInternational = true;
  }

  if (digits.startsWith("972") && digits.length > 3) {
    const local = digits.slice(3).replace(/^0+/, "");
    return local ? `0${local}` : "";
  }

  return isExplicitInternational ? `+${digits}` : digits;
};

export const getPhoneIdentityKey = (value) => {
  const normalized = normalizePhoneForStorage(value);
  const digits = normalizePhoneDigits(normalized);
  if (!digits) return "";
  return digits.startsWith("0") ? `972${digits.slice(1)}` : digits;
};

export const isValidPhone = (value) => /^\d{9,15}$/.test(normalizePhoneDigits(value));
